import { useQuery } from 'react-query';
import request from '../helpers/request';

const getRequestPriorities = async () => {
  const res = await request.get(
    '/Request/priorities',
    {},
    'Не удалось загрузить возможные приоритеты',
    []
  );
  return res;
};

const useRequestPriorities = (options) => {
  return useQuery('priorities', getRequestPriorities, options);
};

export default useRequestPriorities;
